var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 53 53",
    style: {
      fill: "currentColor"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.06 3H4.5A1.5 1.5 0 0 0 3 4.5v19.56a1.5 1.5 0 0 0 1.5 1.5h19.56a1.51 1.51 0 0 0 1.5-1.5V4.5a1.5 1.5 0 0 0-1.5-1.5zm-1.5 19.56H6V6h16.56zm8.83.55h14.67a1.5 1.5 0 0 0 1.5-1.5V6.94a1.51 1.51 0 0 0-1.5-1.5H31.39a1.5 1.5 0 0 0-1.5 1.5v14.67a1.5 1.5 0 0 0 1.5 1.5zm1.5-14.67h11.67v11.67H32.89zM21.61 29.89H6.94a1.5 1.5 0 0 0-1.5 1.5v14.67a1.51 1.51 0 0 0 1.5 1.5h14.67a1.5 1.5 0 0 0 1.5-1.5V31.39a1.5 1.5 0 0 0-1.5-1.5zm-1.5 14.67H8.44V32.89h11.67zM48.5 27.44H28.94a1.51 1.51 0 0 0-1.5 1.5V48.5a1.5 1.5 0 0 0 1.5 1.5H48.5a1.5 1.5 0 0 0 1.5-1.5V28.94a1.5 1.5 0 0 0-1.5-1.5zM47 47H30.44V30.44H47z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.8ec0148a6fe02a2eb47e4bd8903854ee.svg";
export { ForwardRef as ReactComponent };